import { Controller } from "@hotwired/stimulus"
// @ts-expect-error Turbo has dropped TypeScript support
import { Turbo } from "@hotwired/turbo-rails"

// Connects to data-controller="stream-renderer"
export default class StreamRendererController extends Controller {
  static targets = ["template"]

  declare readonly templateTarget: HTMLElement

  render() {
    const templateContent = this.templateTarget.innerHTML
    Turbo.renderStreamMessage(templateContent)
  }
}
